import React from 'react';
import PropTypes from 'prop-types';

import { Translate, SafeAnchor } from '@hydra/common/components';
import { Criterium, CriteriumSkeleton, CriteriumTable } from '@hydra/common/criterium';
import { useReviewContext } from '@hydra/common/context';

const getAdviceVariables = ({ data }) => {
  const firstBadLink = data.links[0] || '';
  const firstBadLinkFixed = firstBadLink.replace(/_/g, '-');
  return {
    firstBadLink,
    firstBadLinkFixed
  };
};

export const UnderscoresUrl = ({ criterium }) => {
  const { data } = criterium;
  const { variant } = useReviewContext();

  const textContent = (data.urlHasUnderscore || data.linkHasUnderscore)
    ? 'underscores_url_ko'
    : 'underscores_url_ok';

  const hasTable = data.links.length > 0;
  const rows = data.links.map(link => [<SafeAnchor href={link} rel='nofollow noopener noreferrer' target='_blank' key={link}>{link}</SafeAnchor>]);

  return (
    <Criterium
      criterium={criterium}
      variables={getAdviceVariables({ data })}
    >
      {variant === 'nocrit' ? <CriteriumSkeleton width='60%' /> : <Translate content={textContent} />}
      {hasTable ? <CriteriumTable rows={rows} striped nowrap /> : null}
    </Criterium>
  );
};

UnderscoresUrl.propTypes = {
  criterium: PropTypes.shape({
    data: PropTypes.shape({
      urlHasUnderscore: PropTypes.bool.isRequired,
      linkHasUnderscore: PropTypes.bool.isRequired,
      links: PropTypes.arrayOf(PropTypes.string)
    })
  })
};

export default React.memo(UnderscoresUrl);
